interface FilterSectionHeaderProps {
  /** Whether to show "Select all" button (default: false) */
  showSelectAll?: boolean;
  /** Select all click handler (required if showSelectAll is true) */
  onSelectAll?: () => void;
}

/**
 * Filter section header component for column filter dropdowns
 *
 * Displays:
 * - "FILTERS" label (left)
 * - "Select all" button (right, optional)
 *
 * Creates visual separation between sorting and filtering sections.
 */
export const FilterSectionHeader = ({
  showSelectAll = false,
  onSelectAll,
}: FilterSectionHeaderProps) => {
  return (
    <div className="flex items-center justify-between px-3 py-2">
      <span className="text-xs font-semibold text-gray-500 dark:text-zinc-500 uppercase tracking-wider">
        Filters
      </span>

      {showSelectAll && onSelectAll && (
        <button
          type="button"
          onClick={onSelectAll}
          className="text-xs font-medium text-blue-600 dark:text-blue-400 hover:underline"
          aria-label="Select all filter options"
        >
          Select all
        </button>
      )}
    </div>
  );
};
